// extracted by mini-css-extract-plugin
export var activeDot = "_20-c";
export var buttonContainer = "_20-9";
export var channelButton = "_20-a";
export var clickable = "_20-d";
export var content = "_20-0";
export var contentFull = "_20-2";
export var contentThird = "_20-1";
export var contentWrapper = "_20-7";
export var description = "_20-5";
export var heightShort = "_20-f";
export var image = "_20-3";
export var imageContainer = "_20-4";
export var selectButton = "_20-e";
export var spinnerContainer = "_20-b";
export var titleContent = "_20-8";
export var titleWrapper = "_20-6";